import React, { useContext, useState } from 'react';
import Moment from 'moment';
import { NavMenu } from './NavMenu';
import { ConnectionAwareBackButton } from './ConnectionStatusBlip';
import { Route, useRouteMatch, useHistory } from 'react-router-dom';
import { Container, Typography, Grid, Button, CircularProgress, Box } from '@mui/material';
import FieldActivityContext from '../contexts/FieldActivityContext';
import StopsContext from '../contexts/StopsContext';
import UserContext from '../contexts/UserContext';
import { green } from '@mui/material/colors';
import FieldActivityFinder from '../utils/updateHelper';
import FieldActivityClosureStatus from '../utils/FieldActivityClosureStatus';
import FieldActivityRemarks from '../utils/FieldActivityRemarks';
import { ConfirmContainerNotOutBody } from './ConfirmCno';
import { ConfirmForemanInvestigateBody } from './ConfirmForemanInvestigate';
import { BottomNav } from './BottomNav';


const ConfirmScreenHeader = (props) => {

    return (
        <NavMenu>
            <ConnectionAwareBackButton />
            <Typography sx={{flexGrow: 1, textAlign: 'center', fontSize: '1.1rem', paddingRight: '50px'}}>
                Confirm Choice
            </Typography>
        </NavMenu>
    );
};


const ConfirmScreenBody = (props) => {
    const history = useHistory();
    const { fieldActivityId } = useContext(FieldActivityContext);
    const { stops, setStops } = useContext(StopsContext);
    //const classes = useStyles();
    const { currentUser } = useContext(UserContext);
    const [loading, setLoading] = useState(false);

    let faObj = stops.find(({FieldActivityId}) => FieldActivityId === fieldActivityId);

    let faClosureStatusCode = '';
    let faRemarkValue = '';
    switch(props.selectionType){
        case 'REPAIRED':
            faClosureStatusCode = FieldActivityClosureStatus.REPAIRED;
            faRemarkValue = FieldActivityRemarks.REPAIRED;
            break;
        case 'REPLACED':
            faClosureStatusCode = FieldActivityClosureStatus.REPLACED;
            faRemarkValue = FieldActivityRemarks.REPLACED;
            break;
        case 'REMOVED':
            faClosureStatusCode = FieldActivityClosureStatus.REMOVED;
            faRemarkValue = FieldActivityRemarks.REMOVED;
            break;
        case 'DELIVERED':
            faClosureStatusCode = FieldActivityClosureStatus.DELIVERED;
            faRemarkValue = FieldActivityRemarks.DELIVERED;
            break;
        // case 'CONTAINER NOT OUT':
        //     faClosureStatusCode = FieldActivityClosureStatus.CONTAINER_NOT_OUT;
        //     faRemarkValue = FieldActivityRemarks.CONTAINER_NOT_OUT;
        //     break;
        // case 'FOREMAN INVESTIGATE':
        //     break;
        default:
    }

    const handleClickNo = () => {
        history.goBack();
    };

    const goBackToRouteScreen = () => {
        history.go(-2);
    };

    const handleClickYes = () => {
        const now = Moment().format('MM/DD/YYYY h:mm A');
        setLoading(true);

        //update fa in app
        const newStops = [...stops];
        let faForUpdate = FieldActivityFinder(newStops, fieldActivityId);
        faForUpdate.update.FieldActivityRemark = props.selectionType;
        faForUpdate.update.FieldActivityRemarkValue = faRemarkValue;
        faForUpdate.update.DynamicsClosureStatus = faClosureStatusCode;
        faForUpdate.update.ModifiedDateTime = now;
        faForUpdate.update.CompletedDateTime = now;
        faForUpdate.update.Status = 'COMPLETED';
        faForUpdate.update.CompletedBy = currentUser;
        //Synced, ModifiedLocally?
        //faForUpdate.update.Saved = true;
        let logMessage = `Mobile App user ${currentUser} completed FA as ${props.selectionType} at ${now}.`;
        faForUpdate.update.LogMessage = logMessage;
        //clear FI flag if necessry
        faForUpdate.update.ForemanInvestigateFlag = false;

        faForUpdate.update.NeedsToPostLog = true;
        faForUpdate.update.NeedsToUpdateCCB = true;

        if (faObj.ServiceRequestNumber) {
            faForUpdate.update.NeedsToUpdateDynamics = true;
        }

        newStops[faForUpdate.index] = faForUpdate.update;
        setStops(newStops);

        setTimeout(function() {
            //setLoading(false);
            goBackToRouteScreen();
        }, 3000);

    };

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                        style={{textAlign: 'center'}}
                    >
                        <Typography variant="h3" component="h2" gutterBottom style={{ marginTop: 100}}>
                            You have selected {props.selectionType}.
                        </Typography>
                        <Typography variant="h4" gutterBottom>
                            Is this correct?
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{textAlign: 'center'}}>
                        {loading && <CircularProgress size={50} sx={{ color: green[500], position: 'absolute', top: '50%', left: '50%', marginTop: "-12px", marginLeft: "-12px"}} />}
                    </Grid>
                </Box>
            </Container>
            <BottomNav>
                <Button className={"secondary"}  component="a" onClick={handleClickNo}>NO</Button>
                <Button className={"primary"} component="a" onClick={handleClickYes}>YES</Button>
            </BottomNav>
        </React.Fragment>
    );
};


const ConfirmChoiceScreen = ({ match }) => {
    const { fieldActivityId } = useContext(FieldActivityContext);
    const { url } = useRouteMatch();
    const { stops } = useContext(StopsContext);
    let faObj = stops.find(({FieldActivityId}) => FieldActivityId === fieldActivityId);
    let selectedChoice = '';
    switch(faObj.ContainerActionType) {
        case 'PWREPAIR':
            selectedChoice = 'REPAIRED';
            break;
        case 'PWREPLACE':
            selectedChoice = 'REPLACED';
            break;
        case 'PWREMOVE':
            selectedChoice = 'REMOVED';
            break;
        case 'PWDELIVER':
            selectedChoice = 'DELIVERED';
            break;
        default:
            selectedChoice = '';
    }

    return (
        <div>
            <Route path={`${url}/work-complete`}>
                <ConfirmScreenHeader />
                <ConfirmScreenBody selectionType={selectedChoice} faObj={faObj} />
            </Route>
            <Route path={`${url}/container-not-out`}>
                <ConfirmScreenHeader />
                <ConfirmContainerNotOutBody selectionType="CONTAINER NOT OUT" faObj={faObj} />
            </Route>
            <Route path={`${url}/foreman-investigate`}>
                <ConfirmScreenHeader />
                <ConfirmForemanInvestigateBody selectionType="FOREMAN INVESTIGATE" faObj={faObj} />
            </Route>
        </div>
    );

};

export default ConfirmChoiceScreen;